import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link, LinkProps } from '@modernhealth/vital-components';

export type InternalLinkProps = RouterLinkProps & Omit<LinkProps, 'children'>;

export const InternalLink = React.forwardRef<HTMLAnchorElement, InternalLinkProps>(
  ({ children, to, className, ...linkProps }, ref) => (
    <Link className={className}>
      <RouterLink innerRef={ref} to={to} {...linkProps}>
        {children}
      </RouterLink>
    </Link>
  ),
);
